import { useEffect } from "react";
import { useSelector } from "react-redux";

export function useError({ cb, sliceKey }) {
  const errors = useSelector((state) => state[sliceKey].errors);
  const status = useSelector((state) => state[sliceKey].status);

  useEffect(() => {
    if (status === "success") {
      cb();
    }
  }, [status]);

  return { errors, status };
}
